// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BaseComponent from "../../../../engines/components/BaseComponent";
import O1HD from "../../../../engines/gameEngine";
import utilsView from "../../../../engines/libs/utilsView";
import { UIKind } from "../../../define/UIKind";

const {ccclass, property} = cc._decorator;

@ccclass
export default class WeChatNewMessageNotfiy extends BaseComponent {

    @property(cc.Label)
    label: cc.Label = null;

    @property(cc.Button)
    btnClick: cc.Button = null;

    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    start () {
        this.initUI();
    }

    initUI() {
        let textMsg = `收到了${this._carryData.peopleId}的飞鸽传书`;
        this.label.string = textMsg;
        utilsView.refreshLabelUI(this.label);
        let bgNode = this.label.node.parent;
        bgNode.x = bgNode.width;

        cc.tween(bgNode)
        .to(0.5, {x: 0})
        .delay(5)
        .to(0.5, {x: bgNode.width})
        .call(()=> {
            this.destroyNode();
        })
        .start();
    }

    onClickOpenChat() {
        // this.btnClick.interactable = false;
        O1HD.emit('normalMode.onBtnOpenPrefab', null, UIKind.UILayerTag.WE_CHAT);
    }

    // update (dt) {}
}
